import { createReducer, on } from "@ngrx/store";
import { IStatisticsState } from "./interfaces";
import { addRemoveBetRecords, clearBetRecords, updateBetRecord, updateStatisticsLastPageFlag } from "./statistics.actions";
import { EBetSplit, IRoundBet } from "../../core/round/interfaces";
import { createEntityAdapter, EntityAdapter, Update } from "@ngrx/entity";
import { isNumber } from "lodash";
import _clone from "lodash/clone";

export const myBetsAdapter: EntityAdapter<IRoundBet> = createEntityAdapter<IRoundBet>({
    selectId: bet => bet.id,
    sortComparer: sortComparator
});

function sortComparator(a: IRoundBet, b: IRoundBet): number {
    if (a.date && b.date) {
        return b.date - a.date;
    } else {
        return 0;
    }
}

export const initialState: IStatisticsState = {
    myBets: myBetsAdapter.getInitialState(),
    lastModified: 0,
    reachedLastPage: false
};

const reducer = createReducer(initialState,
    on(addRemoveBetRecords, (state: IStatisticsState, props: { bets: IRoundBet[] }) => {
        const newTimestamp: number = Date.now();
        const userBets: IRoundBet[] = _clone(props.bets).sort((a, b) => (b.date ?? 0) - (a.date ?? 0));
        const betRecords: IRoundBet[] = myBetsAdapter.getSelectors().selectAll(state.myBets)
            .filter((b) => {
            return isNumber(b.multiplier) && isNumber(b.cashout);
        }).concat(userBets);
        return {
            ...state,
            myBets: myBetsAdapter.setAll(betRecords, state.myBets),
            lastModified: newTimestamp
        };
    }),
    on(updateBetRecord, (state: IStatisticsState, props: { bet: Partial<IRoundBet> & Pick<IRoundBet, "id"> }) => {
        const stateBet: IRoundBet | undefined = state.myBets.entities[`${props.bet.id}_firstHalf`];
        const newId: string = props.bet.split === EBetSplit.FirstHalf ? `${props.bet.id}_firstHalf` : `${Date.now().toString()}_${props.bet.id}`;
        const betUpdates: Update<IRoundBet>[] = [{
            id: props.bet.split === EBetSplit.SecondHalf ? `${props.bet.id}_firstHalf` : props.bet.id,
            changes: {
                ...props.bet,
                id: newId,
                totalAmount: props.bet.totalAmount ?? (props.bet.split === EBetSplit.FirstHalf ? props.bet.cashout : ((stateBet?.cashout ?? 0) + (props.bet.cashout ?? 0)))
            }
        }];
        if (props.bet.split !== EBetSplit.SecondHalf && stateBet) {
            betUpdates.push({
                id: stateBet.id,
                changes: {
                    id: `${Date.now().toString()}_${stateBet.id}`
                }
            })
        }
        return {
            ...state,
            myBets: myBetsAdapter.updateMany(betUpdates, state.myBets)
        };
    }),
    on(updateStatisticsLastPageFlag, (state: IStatisticsState, props: { reachedLastPage: boolean }) => {
        const newTimestamp: number = Date.now();
        return {
            ...state,
            reachedLastPage: props.reachedLastPage,
            lastModified: newTimestamp
        };
    }),
    on(clearBetRecords, (state: IStatisticsState) => {
        return {
            ...state,
            myBets: myBetsAdapter.getInitialState(),
            reachedLastPage: initialState.reachedLastPage,
            lastModified: 0
        };
    })
);

export function statisticsReducer(state: IStatisticsState, action: any) {
    return reducer(state, action);
}
